(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["product-template"]) return;
  try {
    
  // RECOMMENDATIONS JS START

  // Find the container that will hold the recommendations
  var list = document.querySelector("#products_recommendation");
  // Get the base URL for translated product recommendations
  var baseUrl = list.dataset.baseUrl;
  // Get the product ID to request the product recommendations
  var productId = list.dataset.productId;
  // Create an AJAX request
  var request = new XMLHttpRequest();

  request.open(
    "GET",
    baseUrl + ".json?product_id=" + productId + "&limit=12"
  );

  request.onload = function() {
    if (request.status === 404 || request.status === 422) {
      return hideRecommendationsSection();
    }

    var products = JSON.parse(request.response).products;

    if (products.length === 0) {
      return hideRecommendationsSection();
    }

    // Append product recommendations to the DOM.
    list.innerHTML = products.map(function(product) { return renderProduct(product) }).join("");

    // Reload carousel
  };

  request.onerror = function() {
    hideRecommendationsSection();
  };

  // Send AJAX request
  // but only in case there are no recommendations yet
  if (list.childElementCount == 0) {
    request.send();
  }

  function hideRecommendationsSection() {
    list.style.display = "none";
  }

  function renderProduct(product) {
    return [
      '<a href="' + product.url + '" class="card">',
          '<div class="card__cover">',
              '<img class="product__img" src="' + product.featured_image + '" alt="'+ product.title +'"/>',
          '</div>',
          '<div class="card__body">',
              '<h3 class="card__title">' + product.title + '</h3>',
              '<span class="card__price formatted_price">' + formatMoney(product.price, window.moneyFormat) + '</span>',
          '</div>',
      '</a>',
    ].join("");
  }
  // RECOMMENDATIONS JS END


  $(document).ready(function () {
    //Modal trigger
    // PREORDERS
//    $("body").addClass("modal-on");
//    $("#modal-preorder").fadeIn().addClass("active");

    //Carousel
    $('.js-carousel-matter').slick({
      dots: true,
      infinite: true,
      speed: 500,
      arrows: false
    });

    if (document.querySelector("#products_recommendation").childElementCount > 0) {
      $('.js-carousel-like').slick({
        dots: true,
        infinite: true,
        speed: 300,
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
      });
    }

    // Carousel
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template2"]) return;
  try {
    
  // RECOMMENDATIONS JS START

  // Find the container that will hold the recommendations
  var list = document.querySelector("#products_recommendation");
  // Get the base URL for translated product recommendations
  var baseUrl = list.dataset.baseUrl;
  // Get the product ID to request the product recommendations
  var productId = list.dataset.productId;
  // Create an AJAX request
  var request = new XMLHttpRequest();

  request.open(
    "GET",
    baseUrl + ".json?product_id=" + productId + "&limit=12"
  );

  request.onload = function() {
    if (request.status === 404 || request.status === 422) {
      return hideRecommendationsSection();
    }

    var products = JSON.parse(request.response).products;

    if (products.length === 0) {
      return hideRecommendationsSection();
    }

    // Append product recommendations to the DOM.
    list.innerHTML = products.map(function(product) { return renderProduct(product) }).join("");

    // Reload carousel
  };

  request.onerror = function() {
    hideRecommendationsSection();
  };

  // Send AJAX request
  // but only in case there are no recommendations yet
  if (list.childElementCount == 0) {
    request.send();
  }

  function hideRecommendationsSection() {
    list.style.display = "none";
  }

  function renderProduct(product) {
    return [
      'yolo <a href="' + product.url + '" class="card">',
          '<div class="card__cover">',
              '<img class="product__img" src="' + product.featured_image + '" alt="'+ product.title +'"/>',
          '</div>',
          '<div class="card__body">',
              '<h3 class="card__title">' + product.title + '</h3>',
              '<span class="card__price formatted_price">' + formatMoney(product.price, window.moneyFormat) + '</span>',
          '</div>',
      '</a>',
    ].join("");
  }
  // RECOMMENDATIONS JS END


  $(document).ready(function () {
    //Modal trigger
    // PREORDERS
//    $("body").addClass("modal-on");
//    $("#modal-preorder").fadeIn().addClass("active");

    //Carousel
    $('.js-carousel-matter').slick({
      dots: true,
      infinite: true,
      speed: 500,
      arrows: false
    });

    if (document.querySelector("#products_recommendation").childElementCount > 0) {
      $('.js-carousel-like').slick({
        dots: true,
        infinite: true,
        speed: 300,
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
      });
    }

    // Carousel
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template3"]) return;
  try {
    
  // RECOMMENDATIONS JS START

  // Find the container that will hold the recommendations
  var list = document.querySelector("#products_recommendation");
  // Get the base URL for translated product recommendations
  var baseUrl = list.dataset.baseUrl;
  // Get the product ID to request the product recommendations
  var productId = list.dataset.productId;
  // Create an AJAX request
  var request = new XMLHttpRequest();

  request.open(
    "GET",
    baseUrl + ".json?product_id=" + productId + "&limit=12"
  );

  request.onload = function() {
    if (request.status === 404 || request.status === 422) {
      return hideRecommendationsSection();
    }

    var products = JSON.parse(request.response).products;

    if (products.length === 0) {
      return hideRecommendationsSection();
    }

    // Append product recommendations to the DOM.
    list.innerHTML = products.map(function(product) { return renderProduct(product) }).join("");

    // Reload carousel
  };

  request.onerror = function() {
    hideRecommendationsSection();
  };

  // Send AJAX request
  // but only in case there are no recommendations yet
  if (list.childElementCount == 0) {
    request.send();
  }

  function hideRecommendationsSection() {
    list.style.display = "none";
  }

  function renderProduct(product) {
    return [
      'yolo <a href="' + product.url + '" class="card">',
          '<div class="card__cover">',
              '<img class="product__img" src="' + product.featured_image + '" alt="'+ product.title +'"/>',
          '</div>',
          '<div class="card__body">',
              '<h3 class="card__title">' + product.title + '</h3>',
              '<span class="card__price formatted_price">' + formatMoney(product.price, window.moneyFormat) + '</span>',
          '</div>',
      '</a>',
    ].join("");
  }
  // RECOMMENDATIONS JS END


  $(document).ready(function () {
    //Modal trigger
    // PREORDERS
//    $("body").addClass("modal-on");
//    $("#modal-preorder").fadeIn().addClass("active");

    //Carousel
    $('.js-carousel-matter').slick({
      dots: true,
      infinite: true,
      speed: 500,
      arrows: false
    });

    if (document.querySelector("#products_recommendation").childElementCount > 0) {
      $('.js-carousel-like').slick({
        dots: true,
        infinite: true,
        speed: 300,
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
      });
    }

    // Carousel
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template3_backup"]) return;
  try {
    
  // RECOMMENDATIONS JS START

  // Find the container that will hold the recommendations
  var list = document.querySelector("#products_recommendation");
  // Get the base URL for translated product recommendations
  var baseUrl = list.dataset.baseUrl;
  // Get the product ID to request the product recommendations
  var productId = list.dataset.productId;
  // Create an AJAX request
  var request = new XMLHttpRequest();

  request.open(
    "GET",
    baseUrl + ".json?product_id=" + productId + "&limit=12"
  );

  request.onload = function() {
    if (request.status === 404 || request.status === 422) {
      return hideRecommendationsSection();
    }

    var products = JSON.parse(request.response).products;

    if (products.length === 0) {
      return hideRecommendationsSection();
    }

    // Append product recommendations to the DOM.
    list.innerHTML = products.map(function(product) { return renderProduct(product) }).join("");

    // Reload carousel
  };

  request.onerror = function() {
    hideRecommendationsSection();
  };

  // Send AJAX request
  // but only in case there are no recommendations yet
  if (list.childElementCount == 0) {
    request.send();
  }

  function hideRecommendationsSection() {
    list.style.display = "none";
  }

  function renderProduct(product) {
    return [
      'yolo <a href="' + product.url + '" class="card">',
          '<div class="card__cover">',
              '<img class="product__img" src="' + product.featured_image + '" alt="'+ product.title +'"/>',
          '</div>',
          '<div class="card__body">',
              '<h3 class="card__title">' + product.title + '</h3>',
              '<span class="card__price formatted_price">' + formatMoney(product.price, window.moneyFormat) + '</span>',
          '</div>',
      '</a>',
    ].join("");
  }
  // RECOMMENDATIONS JS END


  $(document).ready(function () {
    //Modal trigger
    // PREORDERS
//    $("body").addClass("modal-on");
//    $("#modal-preorder").fadeIn().addClass("active");

    //Carousel
    $('.js-carousel-matter').slick({
      dots: true,
      infinite: true,
      speed: 500,
      arrows: false
    });

    if (document.querySelector("#products_recommendation").childElementCount > 0) {
      $('.js-carousel-like').slick({
        dots: true,
        infinite: true,
        speed: 300,
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
      });
    }

    // Carousel
  });

  } catch(e) { console.error(e); }
})();

})();
